import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import type { DragHandleProps } from './SortableBlock';

interface Props {
  blockId: string;
  onDelete: (blockId: string) => Promise<void>;
  dragHandleProps?: DragHandleProps;
}

export default function DividerBlock({ blockId, onDelete, dragHandleProps }: Props) {
  return (
    <Box
      sx={{
        position: 'relative',
        my: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        '&:hover .block-delete-btn': { opacity: 1 },
        '&:hover .block-drag-handle': { opacity: 1 },
      }}
    >
      {dragHandleProps && (
        <Box
          ref={dragHandleProps.ref}
          {...dragHandleProps.attributes}
          {...dragHandleProps.listeners}
          className="block-drag-handle"
          sx={{
            display: 'flex',
            cursor: 'grab',
            color: 'text.disabled',
            flexShrink: 0,
            opacity: 0,
            transition: 'opacity 150ms ease-in-out',
            ml: -3,
          }}
          aria-label="Reorder divider"
        >
          <DragIndicatorIcon sx={{ fontSize: 16 }} />
        </Box>
      )}
      <Box sx={{ flex: 1 }}>
        <Divider />
      </Box>
      <IconButton
        className="block-delete-btn"
        size="small"
        onClick={() => onDelete(blockId)}
        aria-label="Delete divider"
        sx={{
          position: 'absolute',
          top: -12,
          right: -4,
          opacity: 0,
          transition: 'opacity 150ms ease-in-out',
          color: 'text.disabled',
        }}
      >
        <CloseIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Box>
  );
}
